<template>
    <component :is="component" :color="color"
        :style="{ width: width + 'px', height: height + 'px', transform: `rotate(${rotate}deg)` }" />
</template>

<script setup>
import { shallowRef, watchEffect, markRaw } from 'vue';

const props = defineProps({
    icon: { type: String, required: true },
    width: { type: Number, default: 25 },
    height: { type: Number, default: 25 },
    color: { type: String, default: '#000' },
    rotate: { type: Number, default: 0 }
});



const component = shallowRef(null);

watchEffect(async () => {
    try {
        const mod = await import(`./components/${props.icon}.vue`);
        component.value = markRaw(mod.default);
    } catch (error) {
        const fallback = await import('./components/Other.vue');
        component.value = markRaw(fallback.default);
    }
});
</script>
